// import PostsRepository from "./postsRepository";
import Service from './service'

const services = {
  // posts: PostsRepository,
  service: Service
  // other repositories ...
}

export const ServiceFactory = {
  get: name => services[name]
}
